import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	TitleBar,
	IconButton,
	CloseIcon
} from '@livechat/ui-kit';
import { Spin } from 'antd';
import { MinusOutlined } from '@ant-design/icons';
import { isMobile } from "react-device-detect";

import Login from './Login';
import MessageHistory from './MessageHistory';
import Survey from './Survey';
import ThankPage from './ThankPage';
import InputBox from './InputBox';
import ConfirmDrawer from './ConfirmDrawer';
import { getAgentStatus, getAgentTypingStatus } from '../redux/reducers/app';
import { getCurrentAgent } from '../redux/reducers/users';
// import { selectDisposition } from '../redux/reducers/dispositions';
import { chatEnded,surveySubmitted } from '../redux/actions/chatAction';

const Maximized = (props) => {
	const { 
		chatState,
		onMessageSend,
		minimize,
		spinning,
		postMessage,
		onCustomerTypingChanged,
		appConfig,
		agentassigned
	} = props;
	const [text, setText] = useState('');
	const [mobileapp,setMobileApp] =useState(false);
	const [customerTyping, setCustomerTyping] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	// const [drawer, setDrawer] = useState(false);
	const agentTypingStatus = useSelector(state => getAgentTypingStatus(state));
	const agentStatus = useSelector(state => getAgentStatus(state));
	const agentName = useSelector(state => getCurrentAgent(state));
	// const disposition = useSelector(selectDisposition);
	const dispatch = useDispatch();
	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			if(text !== '-1') {
				setCustomerTyping(false);
				onCustomerTypingChanged(false);
			}
		}, 1000);
		return () => clearTimeout(delayDebounceFn);
	}, [text]);

	 useEffect (() => {
		const params=new URLSearchParams(window.location.search).get("type");
		const mapp = params?false:true;
		console.log('[ece-chat][Maximise] is it mobile ',mapp);
		if(mapp){
			setMobileApp(mapp);
		}
	 },[])

	const minimizeClicked = () => {
		minimize();
		postMessage('minimize');
	}

	// const drawerMenuClicked = () => {
	// 	setDrawer(!drawer);
	// }
	const closeClicked = () => {
		if(chatState === 'CHATTING') {
			setIsModalVisible(true);
		} else if(chatState === 'ENDED' || chatState === 'SURVEY_SUBMITTED') {
			   // reload page on succsful survey submission
			   window.location.reload(false);
			   localStorage.clear();
		}
		else {
			minimizeClicked();
		}
	
		return;
	}

	const handleInput = (e) => {
		setText(e.target.value);
		if(!customerTyping) {
			setCustomerTyping(true);
			onCustomerTypingChanged(true);
		}
	}

	const handleOk = () => {
		setIsModalVisible(false);
		postMessage('close');
		if(appConfig.survey.enable && agentassigned){
			dispatch(chatEnded());
			localStorage.setItem('laststate','Customer closed the chat');
		} else {
			dispatch(surveySubmitted());
		}
	
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};
    return (
		<Spin spinning={spinning}>
        	<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					borderRadius: isMobile ? 0 : 4,
					border: !mobileapp?'1px solid':'',
					borderColor: '#be272d',
					boxShadow: '0px 3px 16px 1px #666',
				
				}}
			>
				
				{(!mobileapp) && 
					<TitleBar
						// leftIcons={[
						// 	<IconButton key="menu">
						// 		<MenuOutlined onClick={drawerMenuClicked}/>
						// 	</IconButton>	
						// ]}
						rightIcons={[
							<IconButton key="minus" onClick={minimizeClicked}>
								<MinusOutlined />
							</IconButton>,
							<IconButton key="close" onClick={closeClicked}>
								<CloseIcon />
							</IconButton>
						]}
						title="Live Chat"
						className="primary-color title-bar"
					/>
				}
				<div
					style={{
						flexGrow: 1,
						minHeight: 0,
						height: '100%',
					}}
				>
					{/* <ThankPage /> */}
					{agentStatus.status === 'unavailable' ? 
						<ThankPage {...props}/> :
						<>
							{chatState === 'NOT_CHATTING' && <Login {...props} />}
							{chatState === 'CHATTING' && <MessageHistory {...props} />}
							{(chatState === 'ENDED' && agentassigned) ? <Survey  {...props}/>:(chatState === 'ENDED' && <ThankPage {...props}/>)}
							{chatState === 'SURVEY_SUBMITTED' && <ThankPage {...props}/>}
						</>
					}
				</div>
				{agentStatus.show && <div className="chat-indicator">
					<>
					<center>
					Your estimated wait time is <b>{agentStatus.time} </b>
					</center>
					</>
					</div>}
				{chatState === 'CHATTING' && agentTypingStatus && 
					<div className="chat-indicator"> {agentName} is typing...</div>
				}
				{chatState === 'CHATTING' &&
					<InputBox
						text={text}
						setText={setText}
						handleInput={handleInput}
						onMessageSend={onMessageSend}
					/>
				}
				{/* <div className="footer">
					<div>Powered by <b>Spinsci</b></div>
					<div className='uuid'>{disposition.genericId}</div>
				</div> */}
				<div className="footer">
					<div></div>
					<div className='uuid'>{process.env.REACT_APP_VERSION}</div>
				</div>
				{/* <div className="drawer">
				<Drawer
					placement={"left"}
					closable={false}
					onClose={drawerMenuClicked}
					visible={drawer}
				>
					<p> <SaveOutlined/> &nbsp; Save Transcript</p>
					<Divider />
					<p><PrinterOutlined /> &nbsp; Print Transcript</p>
					<Divider />
				</Drawer>
				</div> */}
			</div>
			<ConfirmDrawer 
				visible={isModalVisible} 
				onOk={handleOk} 
				onCancel={handleCancel}
				style={{ position: 'absolute' }}
			/>
		</Spin>
	);
}

export default Maximized;